module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.open
    }
  }, [_c('a', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "auto",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Notificação")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-sub dk"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'policiacivil.notificacao.situacaoavisorecebimento'
      }
    }
  }, [_c('span', [_vm._v("Situações de Aviso de Recebimento")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right text-muted"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-right text"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-fw fa-angle-down text-active"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-sub-header"
  }, [_c('a', [_c('span', {
    staticClass: "text-muted teste"
  }, [_vm._v("Polícia Civil")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fb1d9b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/menu/policiacivil/configuracoes/Notificacao.vue
// module id = 1840
// module chunks = 17